import React, {useState} from 'react';
import { Col, Row } from 'reactstrap';

import TypeUdnForm from "./_form";
import TypeUdnList from "./_list";
import {ButtonNew} from "../../../components/buttons/buttonsActions";


export default function TypeUdn(){

    const [collapseForm, setCollapseForm] = useState(false);
    const [, setEditMode] = useState(false);
    const [item, setItem] = useState();

    const toggleForm = () => {
        setEditMode(false);
        setCollapseForm(!collapseForm);
        setItem(null);
    }

    const beginEdit = (data) => {
        setEditMode(true);
        setCollapseForm(!collapseForm);
        setItem(data);
    }

    return (
        <div>
            {/*--------------------------------------------------------------------------------*/}
            {/* Header*/}
            {/*--------------------------------------------------------------------------------*/}
            <Row>
                <Col md="12">
                    <div className="d-flex align-items-center">
                        {
                            !collapseForm ?
                                <div className="ml-auto paddingAdd">
                                    <ButtonNew onClick={toggleForm}/>
                                </div> : null
                        }
                    </div>
                </Col>
            </Row>
            {/* --------------------------------------------------------------------------------*/}
            {/* Listado*/}
            {/* --------------------------------------------------------------------------------*/}
            <Row>
                <Col md="12">
                    {!collapseForm ? <TypeUdnList beginEdit={beginEdit}/> : null}
                </Col>
            </Row>
            {/* --------------------------------------------------------------------------------*/}
            {/* Formulario*/}
            {/* --------------------------------------------------------------------------------*/}
            <Row>
                <Col md="12">
                    {collapseForm ? <TypeUdnForm toggleParent={toggleForm} item={item}/> : null}
                </Col>
            </Row>
        </div>
    );
}
